/*
 * Copyright (c) 2019. Willker Gomes
 */

import api, { endpoints } from '~/services/api';

class ProductModalityService {
  static getProductModalities = async (filter) => {
    const { data: response } = await api.post(
      endpoints.product.modality.getProductModalities, filter);
    return response.data;
  };
}
export default ProductModalityService;
